<template>
  <modal
    id="updated-term-modal"
    :size="'lg'"
    :confirm-text="'Agree'"
    confirm-class="btn-primary"
    @confirm="updateDate"
    :close-text="'Disagree'"
    close-class="btn-default pull-left"
    @closed="showDeleteModal"
    :isLoading="false"
    :showExit="false"
    data-testid="updated-term-modal"
  >
    <template v-slot:title>Updated Terms of Use</template>
    <template v-slot:body>
      <object
        class="updated-terms-doc"
        data="/capsiminbox/resources/CapsimInbox_Authoring_Platform_License_and_Distribution_Agreement_2_19_21.pdf#toolbar=0"
      ></object>

      <div class="mt-20">
        To continue to the CapsimInbox Authoring Platform, indicate acceptance of these terms and
        conditions by clicking "Agree" below.
      </div>
    </template>
  </modal>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        isAgreed: false,
      };
    },

    methods: {
      ...mapActions('user', ['agreeToTos']),

      async updateDate() {
        try {
          this.isAgreed = true;
          $('#delete-modal').modal('hide');
          $('#updated-term-modal').modal('hide');
          await this.agreeToTos({ isAgreed: this.isAgreed });
        } catch (e) {
          this.$store.commit(
            'SET_ALERT',
            { message: 'There was a problem while updating user agreement', isWarning: true },
            { root: true }
          );
        }
      },

      showDeleteModal() {
        if (!this.isAgreed) {
          this.$emit('showDeleteModal', this.isAgreed);
          $('#updated-term-modal').modal('hide');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .updated-terms-doc {
    width: 100%;
    height: 600px;
  }
</style>
